import * as React from "react";
import { SurveyStep, Question, Answer } from "../types";
import TextareaAutosize from "react-autosize-textarea";

interface DispatchProps {
  goToCovidStep: (step: SurveyStep) => void;
  processQuestion: (question: Question) => void;
}

interface OwnState {
  submitDisabled: boolean;
  selectedAnswer: Answer | null;
  comment: string;
}

type Props = DispatchProps;

class PatientInfo extends React.PureComponent<Props, OwnState> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public continueButton: any;

  public constructor(props: Props) {
    super(props);

    this.state = {
      submitDisabled: true,
      selectedAnswer: null,
      comment: ""
    };

    this.commentChanged = this.commentChanged.bind(this);
    this.selectAnswer = this.selectAnswer.bind(this);
  }

  private commentChanged = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ comment: e.target.value });
  };

  private selectAnswer = (answer: Answer) => {
    this.setState({ selectedAnswer: answer, submitDisabled: false });
  };

  private submitQuestion = () => {
    this.props.goToCovidStep(SurveyStep.SentConfirmation);
    this.setState({ selectedAnswer: null, comment: "", submitDisabled: true });
  };

  public render() {
    return (
      <>
        <div className="position-absolute">
          <div className="header">
            Please provide your information so that we may contact you directly.
          </div>
          <div className="body white">
            <label htmlFor="firstname">First Name</label>
            <input id="firstname" className="form-control"></input>

            <label htmlFor="lastname">Last Name</label>
            <input id="lastname" className="form-control"></input>

            <label htmlFor="dob">Date of Birth</label>
            <input id="dob" className="form-control"></input>

            <label htmlFor="phone">Phone Number</label>
            <input id="phone" className="form-control"></input>

            <label htmlFor="media_input">
              Any additional information you would like for us to know about your situation?
            </label>
            <TextareaAutosize
              id="form_message_text"
              className="form-control text-area mt-5"
              value={this.state.comment}
              onChange={this.commentChanged}
            />

            <div className="mt-15 flex-justify-center">
              <button className="highlight" onClick={this.submitQuestion}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PatientInfo;
